import styled from "styled-components";
import { responsive } from "theme/reponsive";

export const StyledHeroSectionWrapper = styled.div`
   position: relative;
   min-height: 50vh;
   background-color: #fff;
   overflow: hidden;
   background-position: center;
   background-size: cover;
   width: 100%;
   ${responsive("$small")`
      min-height: 450px;
   `}
`;
export const StyledHeroSectionFlexWrapper = styled.div`
   display: flex;
   justify-content: space-between;
   align-items: center;
   flex-direction: column;
   padding: 5.6rem 0;
   gap: 2rem;

   .hero-content {
      max-width: 100%;
      display: flex;
      flex-direction: column;
      gap: 3.2rem;
      align-items: center;

      .hero-content-text {
         text-align: center;
         line-height: 3rem;
         font-size: 2.4rem;
         .blue-text {
            color: ${({ theme }) => theme.colors?.primary};
         }
      }
   }

   @media (min-width: 768px) {
      flex-direction: row;
      padding: 5.6rem 0;

      .hero-content {
         max-width: 54.5rem;
         align-items: initial;

         .hero-content-text {
            text-align: left;
            line-height: 5rem;
         }
      }
   }
   @media (min-width: 425px) {
      .hero-content {
         .hero-content-text {
            font-size: 4.8rem;
            line-height: 5rem;
         }
      }
   }
`;

export const StyledHeroImageWrapper = styled.div`
   &.web-image {
      display: none;
   }
   &.mobile-image {
      display: block;
   }

   @media (min-width: 767px) {
      &.web-image {
         display: block;
      }
      &.mobile-image {
         display: none;
      }
   }
`;
export const StyledHeroImageContentWrapper = styled.div`
   position: absolute;
   bottom: 0;
   right: 0;
`;
export const StyledHeroImageContentItem = styled.div`
   position: absolute;
   border-radius: 8px;
   background-color: #fff;
   box-shadow: 0px 4px 30px 0px rgba(0, 0, 0, 0.12);
   display: inline-flex;
   padding: 1.4rem 1.2rem;
   align-items: center;
   gap: 1.6rem;

   .text-content {
      font-size: 1.6rem;
      max-width: 30rem;
      .text-content-heading {
         font-weight: 600;
      }
      .text-content-sub-text {
         margin-top: 8px;
      }
   }
`;

export const RequestFormContainer = styled.div`
   .btn-div {
      width: 100%;
      margin-top: 40px;
      button {
         width: 100%;
      }
   }
   .header {
      margin-bottom: 30px;
      text-align: center;
      h1 {
         color: #091b66;
         font-weight: 600;
         font-size: 24px;
      }
      p {
         color: #666666;
         font-weight: 400;
         font-size: 16px;
      }
   }
`;

export const HeroSectionButtons = styled.div`
   display: flex;
   gap: 10px;
   align-items: center;
   ${responsive("$small")`
       flex-direction: column;
      justify-content: center;
   `}
`;

export const LoanSection = styled.div`
   height: 100%;
   width: 100%;
   display: flex;
   justify-content: center;
   align-items: center;
`;

export const SchoolLoanContainer = styled.div`
   background-color: #fff;
   margin-top: 100px;
   width: 80%;
   display: flex;
   justify-content: center;
   @media screen and (max-width: 768px) {
      width: 100%;
      padding: 10px;
   }
`;
